import React, { useState, useEffect } from 'react'
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbreact/dist/css/mdb.css';

import { useLocation, useNavigate, useParams } from 'react-router-dom';

//Componentes
import Cookies from 'universal-cookie'

//BLUEMOON
import Logo from '../paginas/img/Logo fondo blanco-03.png'
import '../paginas/estilos/estilos_admin.css'
import Avatar from '../paginas/img/avatar.jpg'

import '../paginas/estilos/estilos.css'

import BotonAdmin from '../componentesAdmin/componentes/BotonAdmin.js'
import HeaderUserPrin from '../componentesAdmin/componentes/HeaderUserPrin.js'
import useTraeDatos from '../componentesAdmin/hooks/useTraeDatos';

// //Modulos
import UsuariosAdmin from '../componentesAdmin/usuarios/UsuariosAdmin'
import CursosAdmin from '../componentesAdmin/cursos/CursosAdmin'
import TemasAdmin from '../componentesAdmin/temas/TemasAdmin'
import AprobadosAdmin from '../componentesAdmin/aprobados/AprobadosAdmin'

import CertificadosAdmin from '../componentesAdmin/certificados/CertificadosAdmin.js'
import OpcionesPagina from '../componentesAdmin/componentes/CreadorPaginas/componentes/OpcionesPagina';
import { useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faX } from '@fortawesome/free-solid-svg-icons';


const Admin = () => {
	const location = useLocation()
	const childRef = useRef();

	const APLICACION = process.env.REACT_APP_NAME_APP
	//almacena toda la data de mediodePagos 
	const cookies = new Cookies()

	//const {baseUrl, titulo, sede, nombreImpuesto, urlProducto} = _config._config
	const baseUrl = process.env.REACT_APP_BASE_URL
	//console.log('baseUrl',baseUrl)
	const api = process.env.REACT_APP_API
	const NombreUsuario = cookies.get('nombre')
	const idUsuario = cookies.get('id')
	const Usuario = cookies.get('usuario')
	const Roll = cookies.get('roll')
	//const history = useHistory();
	const navigate = useNavigate();
	const nombreImpuesto = process.env.REACT_APP_NOMBRE_INPUESTO

	//Urls

	const urlUsuarios = baseUrl + api + 'usuarios/'
	const urlCursos = baseUrl + api + 'cursos/'
	const urlTemas = baseUrl + api + 'temas/'
	const urlAprobados = baseUrl + api + 'aprobados/'

	const urlProductos = baseUrl + api + 'productos/'
	const urlPedidos = baseUrl + api + 'pedidos/'
	const urlCertificados = baseUrl + api + 'certificados/'


	//ESTADOS
	const [cursos] = useTraeDatos(urlCursos)
	const [menuActive, setMenuActive] = useState(true)

	//---------------------PAGINA DE INICIO -----------------------
	const [seleccionado, setSeleccionado] = useState(location?.state?.url === "Inventario" ? "Inventario" : Roll === 'Master' ? 'Actividades' : Roll === 'Comercial' ? 'Pedidos' : 'Cursos')
	const [mostrarOpciones, setMostrarOpciones] = useState(false)
	const [tipoElementoSeleccionado, setTipoElementoSeleccionado] = useState({})
	//-------------------------------------------------------------

	const seleccionar = pagina => e => {
		setSeleccionado(pagina)
		setMostrarOpciones(false)
	}

	const cerrarSesion = (nombre) => e => {
		cookies.remove('id', { path: "/" })
		cookies.remove('nombre', { path: "/" })
		cookies.remove('usuario', { path: "/" })
		cookies.remove('roll', { path: "/" })
		navigate('/');
	}

	useEffect(() => {
		document.title = "Admin - Bajo las Alitas de mamá"

		if (!cookies.get('usuario')) {
			//history.push("/")
			navigate("/")
		}

	}, [])



	const editarChildren = (props) => {
		setMostrarOpciones(false)
		setTimeout(() => {
			setMostrarOpciones(true)
			setTipoElementoSeleccionado(props)
		}, 100);
	}

	const handleEstilosComponente = (props) => childRef.current.handleEstilosComponente(props)

	const cerrarModal = () => setMostrarOpciones(false)

	return (
		<div className="row principal">
			{
				mostrarOpciones && (
					<div className='opciones-creador-paginas'>
						<div className='barra-izquierda-container'>
							<div className="barra-izquierda-opciones">
								<div className='botones-utiles'>
									<button className="botones-utiles-remover" type='button' onClick={() => setMostrarOpciones(false)}> <FontAwesomeIcon icon={faX} size="lg" /></button>
								</div>
								<OpcionesPagina {...tipoElementoSeleccionado} handleEstilosComponente={handleEstilosComponente} />
							</div>
						</div>
					</div>
				)
			}
			<div className="col-xs-12 col-sm-12 col-md-3">
				<div className="barra_izquierda">

					<HeaderUserPrin Logo={Logo} Avatar={Avatar} nombre={NombreUsuario} idUsuario={idUsuario} Roll={Roll} usuario={Usuario} menuActive={menuActive} setMenuActive={setMenuActive} />

					<div className={menuActive ? 'activo' : 'hidden'}>
						{
							{
								'Admin': <>

									<BotonAdmin nombre={'Cursos'} onClick={seleccionar} active={seleccionado} roll={Roll} verPara={'Vendedor'} />
									<BotonAdmin nombre={'Temas'} onClick={seleccionar} active={seleccionado} roll={Roll} verPara={'Vendedor'} />
									<BotonAdmin nombre={'Actividades'} onClick={seleccionar} active={seleccionado} roll={Roll} />
									<BotonAdmin nombre={'Certificados'} onClick={seleccionar} active={seleccionado} roll={Roll} />
									<BotonAdmin nombre={'Usuarios'} onClick={seleccionar} active={seleccionado} roll={Roll} />
									<BotonAdmin nombre={'Cerrar Sesión'} onClick={cerrarSesion} active={seleccionado} roll={Roll} verPara={'Vendedor'} />
								</>,
							}[Roll]
						}
					</div>

				</div>
			</div>
			<div className="col-xs-12 col-sm-12 col-md-9">
				<div className="barra_derecha">

					<div className="contenedorAdmin">

						<div className="contenedor">


							{seleccionado === 'Certificados' ?
								<CertificadosAdmin
									titulo={'Certificados'}
									urlCertificados={urlCertificados}
									urlUsuarios={urlUsuarios}
									urlCursos={urlCursos}
								/>
								: null}


							{seleccionado === 'Actividades' ?
								<AprobadosAdmin
									urlAprobados={urlAprobados}
									titulo={'Actividades'}
									urlCertificados={urlCertificados}
								/>
								: null}

							{seleccionado === 'Cursos' ?
								<CursosAdmin
									urlCursos={urlCursos}
									titulo={'Cursos'}
								/>
								: null}

							{seleccionado === 'Temas' ?
								<TemasAdmin
									urlTemas={urlTemas}
									titulo={'Temas'}
									urlCursos={urlCursos}
									urlProductos={urlProductos}
								/>
								: null}


							{seleccionado === 'Usuarios' ?
								<UsuariosAdmin
									baseUrl={urlUsuarios}
									Titulo={'Usuarios'}
									cursos={cursos}
									urlPedidos={urlPedidos} />
								: null}


						</div>
					</div>
				</div>
			</div>
		</div>

	)
}



export default Admin